module.exports = __webpack_public_path__ + "static/img/03.27c5e52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/tell_tex/03.jpg
// module id = 453
// module chunks = 1